<div class="app-body">
    <main class="main">
      <div class="container-fluid">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>  